function AngryIcon() {
    return (
        <>
            <path
                d='M22.498 4.557c.735 0 1.685.568 2.502 2.21l3.227 6.455v0c.288.584.784 1.11 1.321 1.506.472.348 1.028.635 1.59.773l.24.05 5.848.972c1.74.29 2.558 1.02 2.785 1.726.227.705-.011 1.77-1.264 3.015l-4.55 4.549c-.497.497-.848 1.185-1.045 1.873-.197.689-.262 1.456-.108 2.14v.004l1.301 5.627v.001c.499 2.165.08 3.281-.487 3.695-.533.388-1.618.464-3.33-.46l-.35-.198-5.481-3.246c-.64-.378-1.436-.544-2.19-.544-.756 0-1.554.166-2.199.541l-.005.003-5.482 3.245c-1.903 1.13-3.1 1.07-3.672.652-.571-.417-.993-1.536-.495-3.687l1.302-5.629v-.004c.154-.684.088-1.451-.109-2.14-.197-.688-.547-1.376-1.045-1.873l-4.547-4.547c-1.245-1.245-1.485-2.311-1.26-3.018.212-.661.939-1.344 2.463-1.666l.315-.06 5.848-.97h.002c.634-.108 1.278-.428 1.814-.825.534-.396 1.029-.922 1.316-1.506l.001.001 3.226-6.454c.826-1.642 1.781-2.211 2.518-2.211z'
                strokeWidth={1.5}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                className='mouth'
                d='M18.497 20.889a1.13 1.13 0 100-2.262 1.13 1.13 0 000 2.262zM26.412 20.889a1.13 1.13 0 100-2.262 1.13 1.13 0 000 2.262zM17.996 29.715c-.33-.009-.524-.326-.524-1.182 0-2.841 4.167-2.93 4.976-2.92.776-.01 4.99.063 4.99 2.92 0 .83-.181 1.153-.493 1.18'
                fill='#C6C6C6'
            />
        </>
    );
}

export default AngryIcon;

